import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import ChartAlgoDisplay from './ChartAlgoDisplay';
import {getStockAlgoList } from '../../service/Stratergy';
import PubSub from 'pubsub-js';

class AllChartAlgoDisplay extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stockAlgoList: getStockAlgoList()
		};
		console.log('symbol', this.props.symbol);
	}

	componentDidMount() {
		PubSub.publish('chartAlgoDisplay', this.state.stockAlgoList);
		window.scrollTo(0, 0);
	}

	capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

	render() {
		console.log('AllChartAlgoDisplay data', this.state.stockAlgoList);
		let symbol = this.state.stockAlgoList.quote.symbol;
		let interval = this.capitalizeFirstLetter(this.state.stockAlgoList.quote.interval);
		return (
			<>
				<Helmet>
					<meta charSet="utf-8" />
					<link rel="canonical" href="https://www.vizfm.com/algoBacktestResult" />
					<meta name="description" content="Algorithmic Trade Signals and Backtest results" />
				</Helmet>
				<Container fluid className="p-2">
					<Row>
						<Col>
							Algorithimic Trade Signal/Backtest Result - {symbol} - {interval}
						</Col>
					</Row>
					<Row>
						<Col>
							<ChartAlgoDisplay limit={200} text={'BEST Algo. Signal*'} order={0} />
						</Col>
						<Col>
							<ChartAlgoDisplay limit={200} text={'Algo. Signal*'} order={1} />
						</Col>
					</Row>
					<Row>
						<Col>
							<ChartAlgoDisplay limit={200} text={'Algo. Signal*'} order={2} />
						</Col>
						<Col>
							<ChartAlgoDisplay limit={200} text={'Algo. Signal*'} order={3} />
						</Col>
					</Row>
				</Container>
			</>
		)
	}
}

export default AllChartAlgoDisplay;

